import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ComponentBase, DialogService } from '@definitiv-packages/angular-dba-library';

import { AppService, ProjectLanguage, ProjektPermissionService, SafetyPointFormModelView, SafetyPointFormModelViewService } from '../../../../../roofsafetymanagement-library/src/public-api';

@Component({
  selector: 'app-safetypointform-dialog',
  templateUrl: './safetypointform-dialog.component.html',
  styleUrls: ['./safetypointform-dialog.component.scss'],
  standalone: false
})
export class SafetyPointFormComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  Abbrechen() {
    throw new Error('Method not implemented.');
  }
  openDokument() {
    throw new Error('Method not implemented.');
  }
  public Title: string = "";
  public UserIsAdmin: boolean = false;

  public AdminNotizenArray: { id: number; value: string }[] = [];
  public SafetyPointformularNotizenArray: [] = [];
  public FormGroup = new UntypedFormGroup({

  });

  @ViewChild('stepper') private myStepper: MatStepper | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: SafetyPointFormModelView,
    private dialog: MatDialogRef<SafetyPointFormComponent>,

    private dialogService: DialogService,
    private safetyPointFormModelViewService: SafetyPointFormModelViewService,
    private appService: AppService,
    public permission: ProjektPermissionService,
    private snackbar: MatSnackBar,
  ) {
    super();
    this.language = this.languageService.getLanguageAsSetter();
  }

  public async ngOnInit(): Promise<void> {
    this.loading = true;

    var res = this.safetyPointFormModelViewService.getFilteredList({ SafetyPointId: 1 })
    this.UserIsAdmin = this.appService.isUserAdmin();
    this.Title = "";
    //   var res = await this.formularViewService.getList();
  }

}
